import styled from 'styled-components';
import colors from 'constants/colors';

export const FloorNumbers = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;

  .number {
    background-color: ${colors.charcoal};
    color: ${colors.dimGrey};
    width: 34px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    margin: 5px;
    border-radius: 50%;
    position: relative;
    font-size: 19px;
    font-weight: bold;

    @media only screen and (min-width: 767px) and (max-width: 1200px) {
      width: 51px;
      height: 51px;
      line-height: 51px;
      font-size: 24px;
    }

    @media only screen and (max-width: 767px) {
      width: 28px;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
    }
  }

  .number.active {
    background-color: ${colors.white};
    color: ${colors.black1};
  }
`;

export const ViewLegend = styled.div`
  color: ${({active})=>active? colors.lightBlue: colors.white};
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-left: 40px;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE10+/Edge */
  user-select: none;         /* standard */

  img {
    width: 34px;
    height: 25px;
    display: inline-block;
    margin-right: 10px;
  }

  div {
    white-space: nowrap;
    padding: 5px;
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    img{
      width: 40px;
      height: 29px;
    }
  }
              
  @media only screen and (max-width: 767px) {
    
    margin-left: 0;
    img{
      width: 26px;
      height: 19px;
    }
  }
`;
